//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import logger from "@/utils/logger";

export default {
  data() {
    return {
      loadComplete: false,
      fetchDataTimeout: null,
      selected: [],
      loading: false,
      debounceTimer: null,
      orderItems: [],
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: "ProductNumber",
        descending: true,
      },
      columns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produktnummer",
          field: "productNumber",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produktnavn",
          field: "productName",
          sortable: true,
        },
        {
          name: "numberOfItems",
          align: "left",
          label: "Antall til bestilling",
          field: "numberOfItems",
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
  },
  watch: {
    searchQuery: {
      handler: "onSearchQueryChange"
    },
    visibleColumns: {
      handler(newVal) {
        this.$cookies.set("productColumns", newVal.join(","), "1Y");
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("main", [
      //"getSuggestedOrderItems",
      "postPurchaseOrderFromOrderItems",
      "getReferencesPaginatedSuggestedOrderItems",      
    ]),

    async refresh() {
      this.orderItems = [];
      this.selected = [];
      this.loadComplete = false;
      this.fetchData();
      this.loadComplete = true;
      window.dispatchEvent(new Event("resize"));
      // this.getSuggestedOrderItems().then((result) => {
      //   this.orderItems = result;
      //   this.loadComplete = true;
      //   window.dispatchEvent(new Event("resize"));
      // });
    },


    getSortOrder(col) {
      if (col.sortable && col.name === this.pagination.sortBy) {
        return this.pagination.descending ? "desc" : "asc";
      }
      return null;
    },
    onRequest(params) {
      if (this.loading) return;
      Object.assign(this.pagination, params.pagination);
      this.fetchData();
    },
    onSort(col) {
      if (this.loading) return;
      if (col.sortable) {
        if (this.pagination.sortBy === col.name) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = col.name;
          this.pagination.descending = false;
          this.pagination.page = 1;
        }
        this.fetchData();
      }
    },
    onSearchQueryChange() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.fetchData();
      }, 500);
    },

    fetchData() {
      if (this.fetchDataTimeout) {
        clearTimeout(this.fetchDataTimeout);
      }
      this.fetchDataTimeout = setTimeout(async () => {
        if (this.loading) return;
        this.loading = true;
        let sortBy = this.pagination.sortBy || "ProductNumber";
        let sortDescending = this.pagination.descending;
        const sortColumn = this.columns.find(col => col.name === sortBy);
        if (!sortColumn || !sortColumn.sortable) {
          sortBy = "ProductNumber";
          sortDescending = false;
          Object.assign(this.pagination, {
            sortBy: sortBy,
            descending: sortDescending
          });
        }
        const params = {
          pageNumber: this.pagination.page,
          pageSize: this.pagination.rowsPerPage,
          searchQuery: this.searchQuery,
          sortBy: sortBy,
          sortDescending: sortDescending
        };
        try {
          const data = await this.getReferencesPaginatedSuggestedOrderItems(params);
          this.orderItems = data.items;
          this.pagination.rowsNumber = data.totalCount;
        } catch (error) {
          console.error("Error fetching items:", error);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorFetchingData")
          });
        } finally {
          this.loading = false;
        }
      }, 300);
    },


    async createPurchaseOrders() {
      var items = [];
      this.selected.forEach(function(item) {
        var newItem = {};
        newItem.productId = item.productId;
        newItem.itemText = item.productName;
        newItem.numberOfItems = item.numberOfItems;
        items.push(newItem);
      });

      try {
        await this.postPurchaseOrderFromOrderItems(items);
        this.refresh();
        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk"),
        });
      } catch (error) {
        logger.log("error", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },
  },
};
